module.exports = __webpack_public_path__ + "static/maghrib-bbb1c7f390bd76a19e002ff4bbee1885.jpeg";